module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Szűrő")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "element_type",
      "label": "Típus",
      "name": "element_type",
      "options": _vm.element_types
    },
    on: {
      "input": _vm.getElements
    },
    model: {
      value: (_vm.element_type),
      callback: function($$v) {
        _vm.element_type = $$v
      },
      expression: "element_type"
    }
  })], 1)]), _vm._v(" "), (_vm.element_type != 0) ? _c('div', {
    staticClass: "infobox"
  }, [_c('i', {
    staticClass: "icon fa fa-info-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Figyelem!")]), _vm._v(" Típus váltás előtt menteni kell a beállított értékeket!\n        ")]) : _vm._e(), _vm._v(" "), (this.elements.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Elemek")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.elements), function(element) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(element.element_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(element.group))]), _vm._v(" "), _c('td', [_c('select2', {
      key: 'user_' + element.element_id,
      attrs: {
        "multi": "true",
        "name": 'user_' + element.element_id,
        "id": 'user_' + element.element_id,
        "options": _vm.users
      },
      model: {
        value: (element.user_ids),
        callback: function($$v) {
          _vm.$set(element, "user_ids", $$v)
        },
        expression: "element.user_ids"
      }
    })], 1)])
  }), 0)])]) : _vm._e()])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Csoport")]), _vm._v(" "), _c('th', [_vm._v("Felhasználók")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-038ac678"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/filter.vue
// module id = 276
// module chunks = 0